/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetProductsInput = {
  skus: Array<string | number>;
};

export type GetProductsStockQueryVariables = Exact<{
  input: Types.GetProductsInput;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type GetProductsStockQuery = {
  getProducts: {
    products: Array<{ sku: string; inventoryEntry: { stock: { shelf: number } | null } }>;
  };
};

export type GetUnitsSizesQueryVariables = Exact<{
  input: Types.GetProductsInput;
  isAlwaysInbound?: boolean | null | undefined;
}>;

export type GetUnitsSizesQuery = {
  getProducts: { products: Array<{ sku: string; units: Array<{ quantity: number }> }> };
};

export const GetProductsStockDocument = gql`
  query getProductsStock($input: GetProductsInput!, $isAlwaysInbound: Boolean) {
    getProducts(input: $input, isAlwaysInbound: $isAlwaysInbound) {
      products {
        sku
        inventoryEntry {
          stock {
            shelf
          }
        }
      }
    }
  }
`;

/**
 * __useGetProductsStockQuery__
 *
 * To run a query within a React component, call `useGetProductsStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsStockQuery({
 *   variables: {
 *      input: // value for 'input'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useGetProductsStockQuery(
  baseOptions: Apollo.QueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables> &
    ({ variables: GetProductsStockQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProductsStockQuery, GetProductsStockQueryVariables>(
    GetProductsStockDocument,
    options,
  );
}
export function useGetProductsStockLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProductsStockQuery, GetProductsStockQueryVariables>(
    GetProductsStockDocument,
    options,
  );
}
// @ts-ignore
export function useGetProductsStockSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetProductsStockQuery,
    GetProductsStockQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetProductsStockQuery, GetProductsStockQueryVariables>;
export function useGetProductsStockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetProductsStockQuery | undefined, GetProductsStockQueryVariables>;
export function useGetProductsStockSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetProductsStockQuery, GetProductsStockQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetProductsStockQuery, GetProductsStockQueryVariables>(
    GetProductsStockDocument,
    options,
  );
}
export type GetProductsStockQueryHookResult = ReturnType<typeof useGetProductsStockQuery>;
export type GetProductsStockLazyQueryHookResult = ReturnType<typeof useGetProductsStockLazyQuery>;
export type GetProductsStockSuspenseQueryHookResult = ReturnType<
  typeof useGetProductsStockSuspenseQuery
>;
export type GetProductsStockQueryResult = Apollo.QueryResult<
  GetProductsStockQuery,
  GetProductsStockQueryVariables
>;
export const GetUnitsSizesDocument = gql`
  query getUnitsSizes($input: GetProductsInput!, $isAlwaysInbound: Boolean) {
    getProducts(input: $input, isAlwaysInbound: $isAlwaysInbound) {
      products {
        sku
        units(isAlwaysInbound: $isAlwaysInbound) {
          quantity
        }
      }
    }
  }
`;

/**
 * __useGetUnitsSizesQuery__
 *
 * To run a query within a React component, call `useGetUnitsSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitsSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitsSizesQuery({
 *   variables: {
 *      input: // value for 'input'
 *      isAlwaysInbound: // value for 'isAlwaysInbound'
 *   },
 * });
 */
export function useGetUnitsSizesQuery(
  baseOptions: Apollo.QueryHookOptions<GetUnitsSizesQuery, GetUnitsSizesQueryVariables> &
    ({ variables: GetUnitsSizesQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>(
    GetUnitsSizesDocument,
    options,
  );
}
export function useGetUnitsSizesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>(
    GetUnitsSizesDocument,
    options,
  );
}
// @ts-ignore
export function useGetUnitsSizesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>;
export function useGetUnitsSizesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>,
): Apollo.UseSuspenseQueryResult<GetUnitsSizesQuery | undefined, GetUnitsSizesQueryVariables>;
export function useGetUnitsSizesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUnitsSizesQuery, GetUnitsSizesQueryVariables>(
    GetUnitsSizesDocument,
    options,
  );
}
export type GetUnitsSizesQueryHookResult = ReturnType<typeof useGetUnitsSizesQuery>;
export type GetUnitsSizesLazyQueryHookResult = ReturnType<typeof useGetUnitsSizesLazyQuery>;
export type GetUnitsSizesSuspenseQueryHookResult = ReturnType<typeof useGetUnitsSizesSuspenseQuery>;
export type GetUnitsSizesQueryResult = Apollo.QueryResult<
  GetUnitsSizesQuery,
  GetUnitsSizesQueryVariables
>;
